import thumbnail from '../../../assets/image/video/thumbnail.jpg'
import thumbnailDesktop from '../../../assets/image/video/thumbnailDesktop.jpg'
import { s3PublicStoragePrefix } from '../../../utility'

type Props = {
  className?: string
}

const Video: React.FC<Props> = ({ className = '' }) => {
  return (
    <div className={className}>
      {/* MOBILE */}
      <video
        src={`${s3PublicStoragePrefix}custom-static-assets/videos/241217_f_SPD_btw25_Wahlprogramm_4x5.mp4`}
        controls
        className="md:hidden w-full"
        poster={thumbnail}
      />
      {/* DESKTOP */}
      <video
        src={`${s3PublicStoragePrefix}custom-static-assets/videos/241217_f_SPD_btw25_Wahlprogramm_16x9.mp4`}
        controls
        className="hidden md:block w-full"
        poster={thumbnailDesktop}
      />
      {/* <video
        src={`${s3PublicStoragePrefix}custom-static-assets/videos/241129_g_SPD_KandiKo_Keyfilm_16x9.mp4`}
        controls
        className="w-full"
        poster={thumbnailDesktop}
      /> */}
    </div>
  )
}

export default Video
